import { render, staticRenderFns } from "./ReligionTable.vue?vue&type=template&id=3426c517&"
import script from "./ReligionTable.vue?vue&type=script&lang=js&"
export * from "./ReligionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports